import React, { useEffect, useRef, useState } from "react";

import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/subtitle/Header";
import SubtitleTools from "../components/subtitle/Tools";
import { setCurrentTab } from "../store/Subtitle/subTitleSlice";
import { getTileImage } from "../utils";

const SubTitle = () => {
  const [isModalVisible, setIsModalVisible] = useState(true);
  const { selectedVideo = null } = useSelector((state) => state.subTitle);
  const [isPlaying, setIsPlaying] = useState(false);
  const vidRef = useRef();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCurrentTab(0));
  }, []);
  const handlePlayVideo = () => {
    if (isPlaying) {
      vidRef?.current?.pause();
      setIsPlaying(false);
    } else {
      vidRef?.current?.play();
      setIsPlaying(true);
    }
  };
  const handleVideoEnd = () => {
    setIsPlaying(false);
  };
  useEffect(() => {
    if (selectedVideo?.filePath) {
      setIsPlaying(false);
    }
  }, [selectedVideo?.filePath]);
  return (
    <div className="min-h-screen flex flex-col bg-gray-100 relative h-full">
      <Header />
      {selectedVideo?.filePath && (
        <button
          className="bottom-[122px] absolute inset-0 m-auto w-24 h-24 bg-red-700 text-white rounded-full hover:bg-blue-700 flex items-center justify-center z-50"
          style={{}}
          onClick={handlePlayVideo}
        >
          <FontAwesomeIcon
            style={{
              height: "3em",
              paddingLeft: `${isPlaying ? "0" : "0.5em"}`,
            }}
            icon={isPlaying ? faPause : faPlay}
          />
        </button>
      )}
      <div className="bg-[#d0d0d0] w-[833.5px] h-[467.2px] mt-6 mx-auto">
        {!!selectedVideo?.filePath && (
          <video
            ref={vidRef}
            className="w-full h-full"
            src={getTileImage(selectedVideo)}
            onEnded={handleVideoEnd}
          />
        )}
      </div>
      <SubtitleTools
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    </div>
  );
};

export default SubTitle;
